import React from "react";
import { FaVial } from "react-icons/fa";
import useSystemVariable from "./shared/useSystemVariable";
import SystemVariablePage from "./shared/SystemVariablePage";
import { normalizeHeader, pickCell, downloadExcelTemplate } from "./shared/excelUtils";
import {
  useListLabTestsMutation, useCreateLabTestMutation,
  useUpdateLabTestMutation, useDeleteLabTestMutation,
  useBulkUpsertLabTestsMutation,
} from "../../store/systemVariablesApi";

const DEFAULT_FORM = { name: "", resultValue: "", unit: "", referenceValue: "" };

const mapExcelRow = (row) => {
  const n = {};
  Object.keys(row || {}).forEach((k) => { n[normalizeHeader(k)] = row[k]; });
  return {
    name: (pickCell(n, ["tahlil", "tahlil adı", "tahlil adi", "test", "analysis", "name"]) || "").toString().trim(),
    resultValue: (pickCell(n, ["sonuç", "sonuc", "sonuç değeri", "sonuc degeri", "result"]) || "").toString().trim(),
    unit: (pickCell(n, ["birim", "sonuç birimi", "sonuc birimi", "unit"]) || "").toString().trim(),
    referenceValue: (pickCell(n, ["referans", "referans değeri", "referans degeri", "reference"]) || "").toString().trim(),
  };
};

const TEMPLATE_ROWS = [
  { Tahlil: "Açlık Kan Şekeri", Sonuç: "132", Birim: "mg/dl", "Referans Değeri": "74 - 106" },
  { Tahlil: "HbA1c", Sonuç: "5.8", Birim: "%", "Referans Değeri": "4.0 - 5.6" },
  { Tahlil: "TSH", Sonuç: "2.1", Birim: "mIU/L", "Referans Değeri": "0.27 - 4.20" },
  { Tahlil: "Hemoglobin", Sonuç: "14.8", Birim: "g/dL", "Referans Değeri": "13.5 - 17.5" },
  { Tahlil: "Vitamin D (25-OH)", Sonuç: "28", Birim: "ng/mL", "Referans Değeri": "20 - 50" },
];

const TABLE_COLUMNS = [
  { key: "name", label: "Tahlil", bold: true },
  { key: "resultValue", label: "Sonuç", width: 140 },
  { key: "unit", label: "Birim", width: 120 },
  { key: "referenceValue", label: "Referans", width: 180 },
];

const FORM_FIELDS = [
  { key: "name", label: "Tahlil", required: true },
  { key: "resultValue", label: "Sonuç" },
  { key: "unit", label: "Birim" },
  { key: "referenceValue", label: "Referans Değeri" },
];

const IMPORT_COLUMNS = [
  { key: "name", label: "Tahlil", bold: true },
  { key: "resultValue", label: "Sonuç" },
  { key: "unit", label: "Birim" },
  { key: "referenceValue", label: "Referans" },
];

export default function LabTests() {
  const vm = useSystemVariable({
    listMutation: useListLabTestsMutation(),
    createMutation: useCreateLabTestMutation(),
    updateMutation: useUpdateLabTestMutation(),
    deleteMutation: useDeleteLabTestMutation(),
    bulkMutation: useBulkUpsertLabTestsMutation(),
    itemsKey: "items",
    idKey: "labTestId",
    defaultForm: DEFAULT_FORM,
    itemToForm: (it) => ({ name: it?.name || "", resultValue: it?.resultValue || "", unit: it?.unit || "", referenceValue: it?.referenceValue || "" }),
    formToPayload: (f) => ({ name: f.name, resultValue: f.resultValue || undefined, unit: f.unit || undefined, referenceValue: f.referenceValue || undefined }),
    entityLabel: "Tahlil",
  });

  return (
    <SystemVariablePage
      icon={<FaVial size={22} />}
      title="Tahlil Şablonları"
      subtitle={<>Alanlar: <b>Tahlil</b>, <b>Sonuç</b>, <b>Birim</b>, <b>Referans Değeri</b></>}
      entityLabel="Tahlil"
      vm={vm}
      tableColumns={TABLE_COLUMNS}
      formFields={FORM_FIELDS}
      importColumns={IMPORT_COLUMNS}
      mapExcelRow={mapExcelRow}
      downloadTemplate={() => downloadExcelTemplate(TEMPLATE_ROWS, "Tahliller", "tahlil_sablonu.xlsx")}
    />
  );
}
